let configuration = {
  'apiRoot': '/api/v1',
  'appRoot': '/',
  'parse.date': 'MM-dd-yy|MM/dd/yy|MMddyy|MM-dd-yyyy|MM/dd/yyyy|Mmddyyyy',
  'parse.time': 'h:mm a|hh:mm a|h:mma|hh:mma|hmma|hhmma|hha|ha',
  'format.date': 'MM/dd/yyyy',
  'format.dateTime': 'MM/dd/yyyy h:mm a',
  'format.time': 'h:mm a',
  'format.currency': '${N}',
  'format.percent': '{N}%',
  'locale': 'en-US',
  'timezone': 'America/New_York'
};

/**
 * Returns the configuration value associated with the specified property name. If no key is specified a copy of the
 * entire configuration object will be return instead.
 *
 * @param {String} key optional The requested configuration value
 */
export function getConfig (key) {
  if (key === undefined || key === null)
  {
    return Object.assign({}, configuration);
  }
  else
  {
    return configuration[key];
  }
}

/**
 * Sets one or more new configuration values into the master configuration object for the application.
 *
 * @param {Object} config Configuration object containing one or more new configuration values to set
 */
export function setConfig (config) {
  Object.assign(configuration, config);
}